import { Plus, Save } from "lucide-react";
import CarouselItem from "./CarouselItem";

const CarouselList = ({ items, onMoveUp, onMoveDown, onDelete, onAddClick, onSave, isSaving, widgetTitle, onWidgetTitleChange }) => {
  return (
    <div className="bg-white rounded-lg border-2 p-4">
      <div className="mb-4">
        <label className="block text-sm font-bold mb-2">Widget Title:</label>
        <input
          type="text"
          value={widgetTitle}
          onChange={(e) => onWidgetTitleChange(e.target.value)}
          className="w-full border border-gray-300 rounded px-3 py-2 bg-white"
          placeholder="Enter widget title"
        />
      </div>

      <div>
        <div className="flex items-center justify-between mb-3">
          <label className="text-sm font-bold">Carousel items:</label>
          <button
            onClick={onAddClick}
            className="flex items-center gap-1 bg-blue-500 hover:bg-blue-600 text-white px-2 py-1 rounded text-sm"
          >
            <Plus size={16} />
            Add item
          </button>
        </div>

        <div className="space-y-2">
          {items?.length > 0 ? (
            items?.map((item, idx) => (
              <CarouselItem
                key={`${item.redirection_id}-${idx}`}
                item={item}
                index={idx}
                onMoveUp={() => onMoveUp(idx)}
                onMoveDown={() => onMoveDown(idx)}
                onDelete={() => onDelete(idx)}
                canMoveUp={idx > 0}
                canMoveDown={idx < items.length - 1}
              />
            ))
          ) : (
            <p className="text-gray-500 text-sm">No items added yet</p>
          )}
        </div>
      </div>

      <button
        onClick={onSave}
        disabled={isSaving || items?.length === 0}
        className="w-full mt-6 flex items-center justify-center gap-2 bg-blue-500 hover:bg-blue-600 disabled:bg-blue-300 text-white px-4 py-3 rounded font-bold"
      >
        <Save size={20} />
        Save Carousel
      </button>
    </div>
  );
};

export default CarouselList;